import { render } from "./CategoryAccount.vue?vue&type=template&id=043e3b5f"
import script from "./CategoryAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryAccount.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/CategoryAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "043e3b5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('043e3b5f', __exports__)) {
    api.reload('043e3b5f', __exports__)
  }
  
  module.hot.accept("./CategoryAccount.vue?vue&type=template&id=043e3b5f", () => {
    api.rerender('043e3b5f', render)
  })

}


export default __exports__